export const styles = {
  ChatHistoryContainer: {
    padding: 8,
    height: "45vh",
    overflowY: "auto",
    overflowX: "hidden",
    marginTop: "8px",
    marginBottom: "12px",
  },

  ChatMessage: {
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    overflowX: "hidden",
  },
  ChatMessageYou: {
    display: "flex",
    fontFamily: 'Consolas, "Courier New", monospace',
    lineHeight: "1.3",
    backgroundColor: "#D7E5F0",
    flexDirection: "row",
    padding: "12px",
    borderRadius: "6px",
    marginBottom: "8px",
    marginLeft: "8px",
    marginRight: "8px",
  },
  ChatMessageMe: {
    display: "flex",
    fontFamily: "Gilroy",
    lineHeight: "1.5",
    flexDirection: "row",
    padding: "12px",
    marginBottom: "8px",
    borderRadius: "6px",
    marginLeft: "8px",
    marginRight: "8px",
    width: "95%",
  },
  WaitingIndicator: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "8px",
    marginBottom: "8px",
  },
};

export default styles;
